import { memo } from "react";
import { DividerProps } from "./props.type";
import { Horizontal, Vertical } from "./styles";

const Divider = (props: DividerProps) => {
  const { vertical, margin, color, ...rest } = props;
  const common = { $margin: margin, $color: color, ...rest };

  if (vertical) {
    return <Vertical {...common} />;
  }

  return <Horizontal {...common} />;
};

export default memo(Divider);
